import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { EditOutlined } from '@material-ui/icons'
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import config from '../../config'
import { TEMPLATE_BLUE } from '../../const/color'
import { TOOLBAR_HEIGHT } from '../../const/layout'
import sendRequest from '../../utils/api'

const styles = theme => ({
  root: {
    width: '100%',
    height: '100%',
  },
  toolbar: theme.mixins.toolbar,
  mainContain: {
    height: `calc(100% - ${TOOLBAR_HEIGHT}px)`,
    width: '100%',
    display: 'flex',
    padding: '20px',
  },
  filterBar: {
    display: 'flex',
    marginBottom: '20px',
  },
  cellHeader: {
    borderColor: '#878889',
    fontSize: '16px',
  },
  cellBody: {
    borderColor: '#e4e5e6',
    padding: 8,
  },
})

const CategoryManagementPage = ({ classes }) => {
  const [categories, setCategories] = useState([])
  const [open, setOpen] = useState(false)

  const [category, setCategory] = useState({
    id: null,
    type: '',
  })

  useEffect(() => {
    sendRequest({
      url: `${config.datalayerEndpoint}?timestamp=${new Date().getTime()}`,
      method: 'GET',
    }).then(res => {
      const categories = Object.values(res.data.categories)
      setCategories(categories)
    })
  }, [])

  const generateTemplate = () => {
    return categories.map(category => (
      <TableRow key={`${category.id}-${category.name}`}>
        <TableCell className={classes.cellBody}>{category.id}</TableCell>
        <TableCell className={classes.cellBody}>{category.name}</TableCell>
        <TableCell className={classes.cellBody}>{category.type}</TableCell>
        <TableCell className={classes.cellBody}>{category.parent}</TableCell>
        <TableCell className={classes.cellBody}>{category.level}</TableCell>
        <TableCell className={classes.cellBody}>
          <Button
            target="_blank"
            variant="contained"
            startIcon={<EditOutlined style={{ fontSize: 14 }} />}
            style={{ background: TEMPLATE_BLUE, color: 'white' }}
            onClick={() => {
              handleOpen(category)
            }}
          >
            Choose Editor
          </Button>
        </TableCell>
      </TableRow>
    ))
  }

  const handleOpen = category => {
    setCategory(category)
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  const handleInputChange = event => {
    category[event.target.name] = event.target.value
    setCategory({ ...category })
  }

  const handleUpdateCategory = event => {
    event.preventDefault()

    sendRequest({
      url: `/publisher/update_category_type`,
      method: 'PUT',
      data: { id: category.id, type: category.type },
    }).then(() => {
      window.location.reload()
    })
  }

  return (
    <div>
      <div className={classes.toolbar} />
      <div className={classes.mainContain}>
        <div style={{ flex: 1 }}>
          <Typography
            variant="h6"
            style={{ fontWeight: 'bold', marginBottom: '1em' }}
          >
            Categories
          </Typography>
          <div>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.cellHeader}>ID</TableCell>
                  <TableCell className={classes.cellHeader}>Name</TableCell>
                  <TableCell className={classes.cellHeader}>Type</TableCell>
                  <TableCell className={classes.cellHeader}>Parent</TableCell>
                  <TableCell className={classes.cellHeader}>Level</TableCell>
                  <TableCell className={classes.cellHeader}>Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>{generateTemplate()}</TableBody>
            </Table>
          </div>
        </div>
      </div>
      <Dialog fullWidth maxWidth="lg" open={open} onClose={handleClose}>
        <form onSubmit={handleUpdateCategory}>
          <DialogTitle id="form-dialog-title">
            Choose Editor for Category: {category.name}
          </DialogTitle>
          <DialogContent style={{ marginBottom: '1em' }}>
            <FormControl fullWidth>
              <InputLabel id="select-label">Editor Type</InputLabel>
              <Select
                name="type"
                labelId="select-label"
                id="demo-simple-select"
                value={category.type}
                label="Editor Type"
                onChange={handleInputChange}
              >
                <MenuItem value={`design`}>Design</MenuItem>
                <MenuItem value={`docs`}>Document</MenuItem>
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button
              variant="contained"
              style={{ background: TEMPLATE_BLUE, color: 'white' }}
              onClick={handleUpdateCategory}
              color="primary"
            >
              Save
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}

CategoryManagementPage.propTypes = {}

export default withStyles(styles)(withRouter(CategoryManagementPage))
